var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "offcanvas offcanvas-end w-50",
      attrs: {
        id: "historyOffcanvas",
        tabindex: "-1",
        "aria-labelledby": "historyOffcanvasLabel",
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "offcanvas-body" },
        [
          _setup.open
            ? _c(_setup.ItemHistory, { attrs: { "form-id": _vm.formId } })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "offcanvas-header" }, [
      _c(
        "h5",
        {
          staticClass: "offcanvas-title",
          attrs: { id: "historyOffcanvasLabel" },
        },
        [_vm._v("History")]
      ),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "offcanvas",
          "aria-label": "Close",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }